import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const shiftTimeService = {
    createShiftTime : (body) => {
        return axios.post(`${baseUrl}/shifts/create`, body)
    },
    fetchShiftTimes : (body) => {
        return axios.post(`${baseUrl}/shifts/list`, body)
    },
    updateShiftTime : (body) => {
        return axios.post(`${baseUrl}/shifts/create`, body)
    }
}

export default shiftTimeService